// @ts-nocheck

(() => {
  "use strict";

  const EL = (globalThis.EspacioLaserV2 =
    globalThis.EspacioLaserV2 || {});

  class EngravingDrag {
    constructor({ state, elements }) {
      if (!state || !elements?.object) {
        throw new Error(
          "[EspacioLaserV2] Drag requiere state y object."
        );
      }

      if (typeof globalThis.interact !== "function") {
        throw new Error(
          "[EspacioLaserV2] InteractJS no está disponible."
        );
      }

      this.state = state;
      this.elements = elements;
      this.object = elements.object;

      this.interactable = null;

      this.init();
    }

    init() {
      this.interactable = interact(this.object).draggable({
        inertia: false,

        ignoreFrom:
          "[data-engraving-rotate-handle], " +
          "[data-engraving-scale-handle], " +
          "button",

        modifiers: [
          interact.modifiers.restrictRect({
            restriction: "parent",
            endOnly: false,
          }),
        ],

        listeners: {
          start: () => {
            this.state.setUI("dragging", true);
            this.state.setUI("selected", true);
          },

          move: (event) => {
            const currentX =
              Number(this.state.transform.x) || 0;

            const currentY =
              Number(this.state.transform.y) || 0;

            const nextX = currentX + event.dx;
            const nextY = currentY + event.dy;

            this.state.setPosition(nextX, nextY);
          },

          end: () => {
            this.state.setUI("dragging", false);
          },
        },
      });
    }

    destroy() {
      if (this.interactable) {
        this.interactable.unset();
        this.interactable = null;
      }
    }
  }

  EL.EngravingDrag = EngravingDrag;
})();